import * as api from '../api';
import { TOKEN_HEADER } from '../constants';
import { getJwtToken } from '../storage';

// Multipart uploads bypass the saga wrapper that normally stamps the JWT,
// so we attach it here to avoid 401s from defaultAuthHandler on the gateway.
const withAuthOptions = (callerOptions) => {
  const jwt = getJwtToken();
  return {
    ...(callerOptions || {}),
    headers: {
      ...((callerOptions && callerOptions.headers) || {}),
      [TOKEN_HEADER]: jwt,
    },
  };
};

export const postReclamationFile = (args) => {
  const {
    options: { siteId: selectedSiteId },
    data: { siteId: reclamationSiteId, reclamationId, file },
  } = args;
  const siteId = reclamationSiteId || selectedSiteId;
  return api.callPostWithFormData(`/manager/sites/${siteId}/reclamations/${reclamationId}/files`, {
    data: file,
    options: args.options,
  });
};

export const deleteReclamationFile = (args) => {
  const {
    options: { siteId },
    data: { reclamationId, fileId },
  } = args;
  return api.callPost(
    `/manager/sites/${siteId}/reclamations/${reclamationId}/files/${fileId}/archive`,
    {
      options: args.options,
    }
  );
};

export const postPurchaseOrderFile = (args) => {
  const {
    options: { siteId },
    data: { purchaseOrderId, file },
  } = args;
  return api.callPostWithFormData(
    `/manager/sites/${siteId}/purchase-orders/${purchaseOrderId}/files`,
    {
      data: file,
      options: args.options,
    }
  );
};

export const deletePurchaseOrderFile = (args) => {
  const {
    options: { siteId },
    data: { purchaseOrderId, fileId },
  } = args;
  return api.callPost(
    `/manager/sites/${siteId}/purchase-orders/${purchaseOrderId}/files/${fileId}/archive`,
    {
      options: args.options,
    }
  );
};

export const postTaskFile = (args) => {
  const {
    options: { siteId },
    data: { taskId, file },
  } = args;
  return api.callPostWithFormData(`/manager/sites/${siteId}/tasks/${taskId}/files`, {
    data: file,
    options: args.options,
  });
};

export const deleteTaskFile = (args) => {
  const {
    options: { siteId },
    data: { taskId, fileId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/tasks/${taskId}/files/${fileId}/archive`, {
    options: args.options,
  });
};

// Tasks v2 per-occurrence file upload. Multipart goes through the legacy
// callPostWithFormData helper because RTK's JSON baseQuery can't ship FormData.
export const postTaskOccurrenceFile = (args) => {
  const {
    options: { siteId },
    data: { occurrenceId, file },
  } = args;
  return api.callPostWithFormData(
    `/manager/sites/${siteId}/task-occurrences/${occurrenceId}/files`,
    {
      data: file,
      options: withAuthOptions(args.options),
    }
  );
};

export const postTaskOccurrenceMedia = (args) => {
  const {
    options: { siteId },
    data: { occurrenceId, file },
  } = args;
  return api.callPostWithFormData(
    `/manager/sites/${siteId}/task-occurrences/${occurrenceId}/media`,
    {
      data: file,
      options: withAuthOptions(args.options),
    }
  );
};

export const postTaskTemplateMedia = (args) => {
  const {
    options: { siteId },
    data: { taskTemplateId, file },
  } = args;
  return api.callPostWithFormData(
    `/manager/sites/${siteId}/task-templates/${taskTemplateId}/media`,
    {
      data: file,
      options: withAuthOptions(args.options),
    }
  );
};

export const postTaskTemplateMediaForGroup = (args) => {
  const {
    options: { groupId },
    data: { taskTemplateId, file },
  } = args;
  return api.callPostWithFormData(
    `/manager/groups/${groupId}/task-templates/${taskTemplateId}/media`,
    {
      data: file,
      options: withAuthOptions(args.options),
    }
  );
};
